import { KeyFeature } from '~/models/classified/types'
import { CategoryId } from '~/models/category/types'
import { ciCheckCircle } from '~/icons/source/light/check-circle'
import { CIcon } from '~/icons/types'
import { ciCalendar } from '~/icons/source/light/calendar'
import { ciMileage } from '~/icons/source/light/mileage'
import { ciEngine } from '~/icons/source/light/engine'
import { ciDashboard } from '~/icons/source/light/dashboard'
import { ciDoors } from '~/icons/source/light/doors'
import { ciTransmission } from '~/icons/source/light/transmission'
import { ciFuel } from '~/icons/source/light/fuel'
import { ciAutonomy } from '~/icons/source/light/autonomy'
import { ciChargingTime } from '~/icons/source/light/charging-time'
import { ciSeats } from '~/icons/source/light/seats'
import { ciAxles } from '~/icons/source/light/axles'
import { ciWeight } from '~/icons/source/light/weight'
import { ciPayload } from '~/icons/source/light/payload'
import { ciAbs } from '~/icons/source/light/abs'
import { ciBarcode } from '~/icons/source/light/barcode'
import { ciLength } from '~/icons/source/light/length'
import { ciHeight } from '~/icons/source/light/height'
import { ciBathroom } from '~/icons/source/light/bathroom'
import { ciBedroom } from '~/icons/source/light/bedroom'
import { ciConstructionYear } from '~/icons/source/light/construction-year'
import { ciSquareMeters } from '~/icons/source/light/square-meters'
import { ciStairs } from '~/icons/source/light/stairs'
import { ciPropeller } from '~/icons/source/light/propeller'
import { ciMotoEngine } from '~/icons/source/light/moto-engine'
import { ciClock } from '~/icons/source/light/clock'
import { resolveCategory } from '~/utils/category'
import { categoriesIconsMappings } from '~/constants/category/icon'

const keyFeaturesIcons: Record<KeyFeature['key'], CIcon> = {
  age: ciCalendar,
  registration: ciCalendar,
  mileage: ciMileage,
  max_mileage: ciMileage,
  engine_size: ciEngine,
  engine_power: ciDashboard,
  doors: ciDoors,
  gearbox_type: ciTransmission,
  gears: ciTransmission,
  fuel_type: ciFuel,
  battery_range: ciAutonomy,
  battery_charge_time: ciChargingTime,
  passengers: ciSeats,
  axles: ciAxles,
  weight: ciWeight,
  payload: ciPayload,
  abs: ciAbs,
  makemodel: ciBarcode,
  length: ciLength,
  height: ciHeight,
  bathrooms: ciBathroom,
  bedrooms: ciBedroom,
  year_of_construction: ciConstructionYear,
  area: ciSquareMeters,
  floor: ciStairs,
  engine_type: ciPropeller
}

export default function useClassifiedKeyFeatures(
  categoryIds: CategoryId[] = []
) {
  const isBoatClassified = categoryIds.includes(CategoryId.BOATS)
  const isTractorClassified = categoryIds.includes(CategoryId.TRACTORS)
  const isBikeClassified = categoryIds.includes(CategoryId.BIKES)

  function getKeyFeatureIcon(keyFeature: KeyFeature) {
    if (keyFeature.key === 'category') {
      return (
        resolveCategory(categoriesIconsMappings, categoryIds) || ciCheckCircle
      )
    }

    if (keyFeature.key === 'engine_size' && isBikeClassified) {
      return ciMotoEngine
    }

    if (
      keyFeature.key === 'mileage' &&
      (isBoatClassified || isTractorClassified)
    ) {
      return ciClock
    }

    return keyFeaturesIcons[keyFeature.key] || ciCheckCircle
  }

  return { getKeyFeatureIcon }
}
